import { isStealDealItem } from "./CartItemRenderer";
import { ApiMenuCartItem, CartItemWithUUID, ReviewedCartApiResponse } from "@swiggy-private/cart-types";
import { isEmpty } from "@swiggy-private/js-utils";

/**
 * Checks if cart contains only steal deal items (no regular items)
 * If cart is empty OR contains only steal deal items, returns true
 * If cart contains any non-steal deal items, returns false
 * @param cartItems - Array of cart items (ApiMenuCartItem or CartItemWithUUID)
 * @param mealItems - Array of meal items (typically empty array)
 * @returns boolean - true if cart should be considered "empty" for steal deal logic
 */
export const isEmptyCartWithStealDealCheck = (
    cartItems: ApiMenuCartItem[] = [],
    mealItems: ReviewedCartApiResponse["mealItems"] = [],
): boolean => {
    // If both arrays are empty, cart is truly empty
    if (isEmpty(cartItems) && isEmpty(mealItems)) {
        return true;
    }

    // If mealItems exist (not steal deal items), cart is not empty
    if (!isEmpty(mealItems)) {
        return false;
    }

    // If cartItems exist, check if they are all steal deal items
    if (!isEmpty(cartItems)) {
        const nonStealDealItems = cartItems.filter((item) => !isStealDealItem(item as CartItemWithUUID));
        return nonStealDealItems.length === 0;
    }

    return true;
};
